import { createOrgSchema } from './schemas/create_org_schema';

app.NewOrgDetailsView = app.BaseDetailsView.extend({
  initialize(options) {
    options.dismissOnSave = true;

    app.BaseDetailsView.prototype.initialize.apply(this, arguments);
  },

  getSchema() {
    return createOrgSchema;
  },

  _save(data, opts, $saveButton) {
    const sourceOrgId = data.sourceOrgId;
    if (!sourceOrgId) {
      app.BaseDetailsView.prototype._save.apply(this, arguments);
      return;
    }

    const collection = new app.ClonableUserList([], { sourceOrgId });
    const listView = new app.UserSelectorListView({
      collection,
      cellOptions: {
        getName: (user) => user.displayName(),
      },
      maxSelectable: null,
    });

    app.showModelSelector(
      {
        modalTitle: `Add users to ${data.name}`,
        modelType: 'user',
        modelListView: listView,
        maxSelectable: 100,
        allowEmpty: true,
      },
      (err, selectedUsers) => {
        if (err) {
          return;
        }
        const usernames = (selectedUsers || []).map((user) => user.get('username'));
        if (usernames.length) {
          data.usernames = usernames;
        }

        app.BaseDetailsView.prototype._save.apply(this, arguments);
      },
    );
  },

  _didSaveModel() {
    app.showSavedToast('Created a New Org!');
    setTimeout(() => {
      window.location.href = this.model.bureauUrl();
    }, 1500);
  },
});
